// extracted by mini-css-extract-plugin
export default {"DHDownloadBlock":"DHDownloadBlock_DHDownloadBlock__KLbnf"};